import React from 'react'
import { Popover, Timeline } from 'antd'
import { HistoryOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import dayjs from '../../../utils/dayjs'

import { CaseStatusColorCodeEnum } from '../../../constants'

const HistoryIcon = styled(HistoryOutlined)`
    margin-left: 6px;
    cursor: pointer;
    color: #595959;
    font-size: 14px;

    &:hover {
        color: #1890ff;
    }
`

const StyledTimeline = styled(Timeline)`
    width: 360px;
    padding-top: 10px;

    .ant-timeline-item:last-of-type {
        padding-bottom: 0;
    }
`

const PopoverTitle = styled.div`
    text-align: center;
    padding-bottom: 5px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    font-weight: 600;
`

const StatusText = styled.span`
    font-weight: bold;
    text-transform: capitalize;
`

const MetaText = styled.span`
    font-size: 0.8rem;
    display: block;
`

const TimelineContent = ({ item }) => (
    <p style={{ margin: 0 }}>
        <StatusText>{item.status}</StatusText>
        {item.physicianName && <MetaText>Assigned to: {item.physicianName}</MetaText>}
        {item.reviewedBy && <MetaText>Reviewed by: {item.reviewedBy}</MetaText>}
        {item.updatedBy && <MetaText>Updated by: {item.updatedBy.toLowerCase()}</MetaText>}
    </p>
)

const HistoryTimeline = ({ statusHistory }) => (
    <StyledTimeline mode="left">
        {statusHistory.map((item, index) => (
            <Timeline.Item
                key={index}
                color={CaseStatusColorCodeEnum[item.status?.toLowerCase()] || '#000'}
                label={dayjs(item.createdAt).format('MMM Do YYYY h:mma')}
            >
                <TimelineContent item={item} />
            </Timeline.Item>
        ))}
    </StyledTimeline>
)

export const StatusHistoryPopover = ({ statusHistory }) => {
    if (!statusHistory?.length) return null

    return (
        <Popover
            content={<HistoryTimeline statusHistory={statusHistory} />}
            title={<PopoverTitle>Case Status History</PopoverTitle>}
            trigger="click"
            placement="bottomLeft"
        >
            <HistoryIcon />
        </Popover>
    )
}
